import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { WaveSmallLeaderboardItemOutcomes } from "@/components/waves/small-leaderboard/WaveSmallLeaderboardItemOutcomes";
interface WaveLeaderboardDropFooterProps {
  readonly drop: ExtendedDrop;
}
export const WaveLeaderboardDropFooter: React.FC<WaveLeaderboardDropFooterProps> = t0 => {
  const $ = _c(2);
  const {
    drop
  } = t0;
  let t1;
  if ($[0] !== drop) {
    t1 = <WaveSmallLeaderboardItemOutcomes drop={drop} />;
    $[0] = drop;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};